import axiosClient from "../api/axiosClient";
import { CheckNullParams } from "../utils/CheckNullParams";
const dealerApi = {
  getDealers: (params) => {
    const url = "agency";
    const payload = CheckNullParams(params);
    return axiosClient.get(url, {
      params: payload,
    });
  },

  getDealer: (id) => {
    const url = "agency";
    return axiosClient.get(url + "/" + id);
  },

  createDealer: (params) => {
    const url = "agency";
    const payload = CheckNullParams(params);
    return axiosClient.post(url, payload);
  },
  
  updateDealer: (id, payload) => {
    const url = "agency/";
    return axiosClient.patch(url + id, payload);
  },

  deleteDealer: (params) => {
    const url = "agency";
    console.log("params", params);
    return axiosClient.delete(url, { params });
  },
};

export default dealerApi;
